"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GtldItem;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _react2 = require("@linaria/react");
const TableRowContainer = /*#__PURE__*/(0, _react2.styled)("tr")({
  name: "TableRowContainer",
  class: "pl-tj7rf4o"
});
const ButtonContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonContainer",
  class: "pl-bejcvy6"
});
const TableDataContainer = /*#__PURE__*/(0, _react2.styled)("td")({
  name: "TableDataContainer",
  class: "pl-trxlnm7"
});

// eslint-disable-next-line react/prop-types
const GtldName = ({
  url,
  name
}) => url ? /*#__PURE__*/_react.default.createElement("a", {
  href: url
}, name) : /*#__PURE__*/_react.default.createElement("span", null, name);
function GtldItem({
  gtld,
  handleGtldCta,
  ctaDesign,
  statusList,
  isFollowing,
  isMobile
}) {
  const status = statusList.find(statusItem => gtld.p === statusItem.id);
  const ctaLabel = isFollowing(gtld) ? status.secondaryCtaText : status.gtldCtaText;
  return /*#__PURE__*/_react.default.createElement(TableRowContainer, {
    "data-cy": `gtld-row-item`
  }, /*#__PURE__*/_react.default.createElement(TableDataContainer, {
    "data-cy": `gtld-tld-item`
  }, /*#__PURE__*/_react.default.createElement(GtldName, gtld)), !isMobile && /*#__PURE__*/_react.default.createElement(TableDataContainer, {
    "data-cy": "gtld-text-item"
  }, status.gtldText), /*#__PURE__*/_react.default.createElement(TableDataContainer, null, /*#__PURE__*/_react.default.createElement(ButtonContainer, null, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    "data-cy": `gtld-cta-item`,
    size: "small",
    design: ctaDesign,
    value: gtld.id,
    text: ctaLabel,
    onClick: handleGtldCta,
    href: gtld.url
  }))));
}
GtldItem.propTypes = {
  handleGtldCta: _propTypes.default.func,
  ctaDesign: _propTypes.default.string,
  statusList: _propTypes.default.array.isRequired,
  isFollowing: _propTypes.default.func,
  isMobile: _propTypes.default.bool,
  gtld: _propTypes.default.shape({
    id: _propTypes.default.number,
    name: _propTypes.default.string,
    url: _propTypes.default.string,
    p: _propTypes.default.number,
    w: _propTypes.default.number,
    c: _propTypes.default.arrayOf(_propTypes.default.number)
  }).isRequired
};